<template>
  <div v-if="invoice" class="container invoice-table">
    <div v-if="!isCreateDisabled">
      <!--      <div v-if="!isBlocked">-->
      <div>
        <button
            class="btn my-2 my-sm-0 float-left" style="width: 150px"
            v-bind:class="isGenError ? 'btn-outline-danger' : 'btn-outline-primary'"
            @click="createInvoice"
            :disabled="isReloadDisabled || editInvoice || isBlocked || isCreateDisabled">
            <span v-if="!isReloadDisabled">
                <span v-if="this.invoice.status === 1">Создать</span>
                <span v-else>Пересоздать</span>
            </span>
          <span v-if="isReloadDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
            </span>
        </button>

        <button
            v-if="!isCancelled"
            class="btn my-2 my-sm-0 float-left btn-outline-primary"
            style="width: 150px; margin-left: 20px"
            @click="cancelInvoice"
            :disabled="isCancelDisabled || isReloadDisabled || editInvoice || isCreateDisabled">
           <span v-if="!isCancelDisabled">
                Отменить
            </span>
          <span v-if="isCancelDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
            </span>
        </button>

        <button
            v-if="isCancelled"
            class="btn my-2 my-sm-0 float-left btn-outline-primary"
            style="width: 150px; margin-left: 20px"
            @click="restoreInvoice"
            :disabled="isReloadDisabled || editInvoice || isBlocked || isCreateDisabled">
          Восстановить
        </button>


        <div v-if="isSuperAdmin">
          <button
              v-if="invoice.is_blocked"
              class="btn my-2 my-sm-0 float-left btn-outline-primary"
              style="width: 150px; margin-left: 20px"
              @click="unblockInvoice()"
              :disabled="isReloadDisabled || editInvoice">
            Разблокировать
          </button>

          <button
              v-if="!invoice.is_blocked"
              class="btn my-2 my-sm-0 float-left btn-outline-primary"
              style="width: 150px; margin-left: 20px"
              @click="blockInvoice()"
              :disabled="isReloadDisabled || editInvoice">
            Заблокировать
          </button>
        </div>

        <div v-if="!isCreateDisabled">
          <div v-if="!invoiceEditDisabled && !isBlocked">
            <div v-if="!editInvoice"
                 @click="openInvoiceEdit"
                 class="cursor-pointer far fa-edit float-right"
                 style="margin-top: 13px; font-size: 18px">
            </div>
            <div v-if="editInvoice"
                 @click="saveInvoice"
                 class="cursor-pointer far fa-save float-right"
                 style="margin-top: 13px; font-size: 20px">
            </div>
            <div v-if="editInvoice"
                 @click="editInvoice = false"
                 class="cursor-pointer fas fa-undo float-right"
                 style="margin-top: 14px; font-size: 17px; margin-right: 9px">
            </div>
          </div>
        </div>

        <div v-if="invoiceEditDisabled">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>


        <br>
        <p><br></p>
      </div>

      <!--      <div v-if="isBlocked">
              <div v-if="!isReloadDisabled">
                <button
                    class="btn my-2 my-sm-0 float-left btn-outline-primary"
                    style="width: 150px"
                    @click="unblockInvoiceStart"
                    :disabled="isReloadDisabled">
                  Редактировать
                </button>
              </div>
              <div v-if="isReloadDisabled" class="float-left">
                <form>
                  Причина<br>
                  <textarea v-model="unblockReason" name="unblock_reason" cols="80" rows="5"></textarea>
                </form>
                <br>
                <button
                    class="btn my-2 my-sm-0 float-left" style="width: 150px"
                    v-bind:class="isSendError ? 'btn-outline-danger' : 'btn-outline-primary'"
                    @click="unblockInvoice">
                  <span>Ok</span>
                </button>
                <button
                    class="btn my-2 my-sm-0 float-left btn-outline-primary"
                    style="width: 150px; margin-left: 20px"
                    @click="reloadDisabled = false">
                  Отмена
                </button>
                <p><br></p>
                <p><br></p>
              </div>
              <p><br></p>
              <p><br></p>
            </div>-->

    </div>

    <div v-if="isSuperAdmin" style="padding-bottom: 50px">
      <button
          class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 150px;"
          @click="CreateCustomReport"
          :disabled="isCreateCustomReportDisabled">
            <span v-if="!isCreateCustomReportDisabled">
                Отчет Gdrive
            </span>
        <span v-if="isCreateCustomReportDisabled" class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true">
            </span>
      </button>

      <button
          class="btn my-2 my-sm-0 float-left btn-outline-primary" style="width: 230px; margin-left: 10px;"
          @click="UploadContractorInvoices"
          :disabled="isUploadContractorInvoices">
            <span v-if="!isUploadContractorInvoices">
                Upload Contractor Invoices
            </span>
        <span v-if="isUploadContractorInvoices" class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true">
            </span>
      </button>
    </div>

    <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>

    <div>
      <table class="table table-sm text-left">
        <tbody>
        <tr>
          <td class="table-td">id</td>
          <td>{{ invoice.id }}</td>
        </tr>
        <tr>
          <td class="table-td">Номер</td>
          <td>
            <div v-if="!editInvoice || !isGutschrift" class="float-left">{{ invoice.number }}
            </div>
            <div v-if="editInvoice && isGutschrift">
              <input type="text" v-model="invoice.number">
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Дата</td>
          <td>
            <div v-if="!editInvoice" class="float-left">{{ invoice.doc_date.toISOString().split('T')[0] }}
            </div>
            <div v-if="editInvoice">
              <input type="date" :value="invoice.doc_date.toISOString().split('T')[0]"
                     @input="updateDocDate">
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Дата выполнения</td>
          <td>
            <div v-if="!editInvoice" class="float-left">
              {{ invoice.date_of_completion.toISOString().split('T')[0]}}
            </div>
            <div v-if="editInvoice">
              <input type="date" :value="invoice.date_of_completion.toISOString().split('T')[0]"
                     @input="updateDateOfCompletion">
            </div>
          </td>
        </tr>
        <tr v-bind:class="{ 'text-danger font-weight-bold': isOverdue }">
          <td class="table-td">Плановая оплата</td>
          <td>
            {{ invoice.due_date }}
            {{ daysOverdue ? '(' + daysOverdue + ' д.)' : '' }}
          </td>
        </tr>
        <tr>
          <td class="table-td">Период</td>
          <td>
            <div class="float-left">{{ invoice.service_period_start }} :
              {{ invoice.service_period_end }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Отменен</td>
          <td v-if="invoice.status != 9">{{ invoice.cancelled ? 'Да' : 'Нет' }}</td>
          <td v-else>
            <router-link :to="{name: 'invoiceItem', params:{
                            doc_id: invoice.storno_invoice_id,
                            countryID: invoice.country_id,
                        }}" target="_blank">{{ invoice.storno_invoice_id }}
            </router-link>
          </td>
        </tr>
        <tr v-if="invoice.status === 9 && invoice.target_invoice_id > 0">
          <td class="table-td">Задания перенесены в</td>
          <td>
            <router-link :to="{name: 'invoiceItem', params:{
                            doc_id: invoice.target_invoice_id,
                            countryID: invoice.country_id,
                        }}" target="_blank">{{ invoice.target_invoice_id }}
            </router-link>
          </td>
        </tr>
        <tr v-if="invoice.type_id === 4 && invoice.source_invoice_id > 0">
          <td class="table-td">Исходный инвойс</td>
          <td>
            <router-link :to="{name: 'invoiceItem', params:{
                            doc_id: invoice.source_invoice_id,
                            countryID: invoice.country_id,
                        }}" target="_blank">{{ invoice.source_invoice_id }}
            </router-link>
          </td>
        </tr>
        <tr>
          <td class="table-td">Клиент</td>
          <td>
            <!--                        <router-link :to="{name: 'customer', params: {id: invoice.customer.id}}">-->
            <a :href="invoice.customer.link"
               target="_blank" rel="noopener">
              {{ invoice.customer.name }}
            </a>
            <!--                        </router-link>-->
          </td>
        </tr>
        <tr>
          <td class="table-td">Франшиза</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.franchise.name }}</div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.franchise_id"
                      @change="updateFranchise">
                <option v-for="item in franchises" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">РС</td>
          <td>{{ invoice.franchise_bank_account.account_number }} в {{
              invoice.franchise_bank_account.bank_name
            }}
          </td>
        </tr>
        <tr>
          <td class="table-td">Юрлицо</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.legal_entity.name }} (ИНН {{
                  invoice.legal_entity.inn
                }}/КПП {{
                  invoice.legal_entity.kpp
                }}{{ invoice.legal_entity.is_deleted ? ' (удалено)' : '' }})
              </div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.legal_entity_id"
                      @change="updateLegalEntity">
                <option v-for="item in invoice.legalEntities" :value="item.id">{{ item.name }}{{
                    item.is_deleted ?
                        ' (удалено)' : ''
                  }}
                </option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Департамент</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.department.name }}{{
                  invoice.department.is_deleted ?
                      '(удален)' : ''
                }}
              </div>
            </div>
            <!--                        <div v-if="editInvoice">-->
            <!--                            <div class="float-left"> {{ invoice.department.name }}</div>-->
            <!--                        </div>-->
            <div v-if="editInvoice">
              <select v-model="invoice.department_id"
                      @change="updateDepartment">
                <option v-for="item in departments" :value="item.id">{{ item.name }}{{
                    item.is_deleted ?
                        '(удален)' : ''
                  }}
                </option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Филиал</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.branch.name }}{{
                  invoice.branch.is_deleted ? ' (удален)'
                      : ''
                }}
              </div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.branch_id"
                      @change="updateBranch">
                <option v-for="item in branches" :value="item.id">{{ item.name }}{{
                    item.is_deleted ?
                        '(удален)' : ''
                  }}
                </option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Договор</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"><a :href="invoice.contract.link" target="_blank" rel="noopener">{{
                  invoice.contract.name
                }} </a></div>
            </div>
            <!--                        <div v-if="editInvoice">-->
            <!--                            <div class="float-left"> {{ invoice.contract.name }}</div>-->
            <!--                        </div>-->
            <div v-if="editInvoice">
              <select v-model="invoice.contract_id"
                      @change="updateContract">
                <option v-for="item in invoice.contracts" :value="item.id">{{ item.name }} {{
                    item.payment_type_id === 1 ? ' (Аванс)' : '(Кредит)'
                  }}
                </option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Агрегация</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.aggregationType.name }}</div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.aggregation_id"
                      @change="updateAggregationType">
                <option v-for="item in aggregationTypes" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Шаблон</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.item_template.name }}</div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.gen_type"
                      @change="updateTemplate">
                <option v-for="item in templates" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Сгенерированное название</td>
          <td>{{ invoice.use_task_name_generated ? 'Да' : 'Нет' }}</td>
        </tr>
        <tr>
          <td class="table-td">Грузополучатель</td>
          <td>{{ invoice.set_consignee ? 'Да' : 'Нет' }}</td>
        </tr>
        <tr>
          <td class="table-td">Включить НДС в цену</td>
          <td>{{ invoice.include_vat_in_price ? 'Да' : 'Нет' }}</td>
        </tr>
        <tr>
          <td class="table-td">Тип</td>
          <td>{{ invoice.type.name }}</td>
        </tr>
        <tr>
          <td class="table-td">Оплата</td>
          <td>{{ invoice.paymentType.name }}</td>
        </tr>
        <tr>
          <td class="table-td">Назначение платежа</td>
          <td>
            <div v-if="!editInvoice || !(invoice.aggregation_id === 3)">
              <div class="float-left"> {{ invoice.payment_purpose }}</div>
            </div>
            <div v-if="editInvoice && (invoice.aggregation_id === 3)">
              <input style="width: 800px" v-model="invoice.payment_purpose" type="text"/>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Статус документа</td>
          <td>{{ statusList[invoice.status] }}</td>
        </tr>
        <tr>
          <td class="table-td">Статус ЭДО</td>
          <td>{{ invoice.edi_status }}</td>
        </tr>
        <tr>
          <td class="table-td">Приглашение ЭДО</td>
          <td>{{ invoice.edi_state }}</td>
        </tr>
        <tr>
          <td class="table-td">Менеджер</td>
          <td>{{ invoice.manager.display_name }}</td>
        </tr>
        <tr>
          <td class="table-td">Подписант</td>
          <td>
            <div v-if="!editInvoice">
              <div class="float-left"> {{ invoice.signer.display_name }}</div>
            </div>
            <div v-if="editInvoice">
              <select v-model="invoice.signer_id"
                      @change="updateSinger">
                <option disabled value="">Please select one</option>
                <option v-for="item in signers" :value="item.id">{{ item.display_name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Сумма по заданиям без НДС</td>
          <td>{{ invoice.summ_gen }}</td>
        </tr>
        <tr>
          <td class="table-td">Сумма без НДС</td>
          <td>
            <!--                        <div class="float-left"> {{ invoice.summ }}</div>-->
            <div v-if="!editInvoice || !(invoice.aggregation_id === 3)">
              <div class="float-left"> {{ invoice.summ }}</div>
            </div>
            <div v-if="editInvoice && (invoice.aggregation_id === 3)">
              <input style="width: 800px" v-model="invoice.summ" @change="updateSum" type="number"/>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-td">Ставка НДС</td>
          <td  v-if="invoice.vat_rate > 0">{{ invoice.vat_rate * 100 }}%</td>
          <td  v-if="invoice.vat_rate == 0">Без НДС</td>
        </tr>
        <tr>
          <td class="table-td">НДС</td>
          <td>{{ invoice.vat_amount }}</td>
        </tr>
        <tr>
          <td class="table-td">Сумма c НДС</td>
          <td>{{ invoice.amount_with_vat }}</td>
        </tr>
        <tr>
          <td class="table-td">Оплата</td>
          <td>{{ invoice.payment_amount }}</td>
        </tr>
        <tr>
          <td class="table-td">Задолженность</td>
          <td>{{ Math.round(invoice.debt_sum * 100) / 100 }}</td>
        </tr>
        <!--<tr>-->
        <!--<td class="table-td">Статус цифровой копии</td>-->

        <!--<td>-->
        <!--{{ invoice.invoiceStatus.digital.current.name }}-->
        <!--<button v-show="invoice.invoiceStatus.digital.next.id > 0" class="btn btn-outline-primary btn-download"-->
        <!--style="width: 140px;"-->
        <!--@click="updateStatusDigital(invoice.invoiceStatus.digital.next.id)"-->
        <!--:disabled="isStatusDigitalNextDisabled">-->
        <!--<div v-if="!isStatusDigitalNextDisabled">-->
        <!--<div>=> отправлен</div>-->
        <!--</div>-->
        <!--<div v-if="isStatusDigitalNextDisabled" class="loader"></div>-->
        <!--</button>-->

        <!--</td>-->
        <!--</tr>-->
        <!--<tr>-->
        <!--<td class="table-td">Статус оригинала</td>-->
        <!--<td>{{ invoice.invoiceStatus.original.current.name }}</td>-->
        <!--</tr>-->
        <tr>
          <td class="table-td">GUID</td>
          <td>{{ invoice.guid }}</td>
        </tr>
        <tr v-if="isGutschrift">
          <td class="table-td">Файлы</td>
          <td v-if="!isFilePrepared"><input type="file" accept="application/pdf"
                                            @change="OnFileGutschriftChanged">
          </td>
          <td v-else> {{ this.selectedFile.name }}
            <button @click="FileGutschriftUpload" :disabled="isFileUploadDisabled">Загрузить</button>
          </td>
        </tr>
        <tr v-if="isConfirmationRequired">
          <td class="table-td">Согласование</td>
          <td v-if="!isFilePrepared"><input type="file" accept="application/pdf"
                                            @change="OnFileConfirmationChanged">
          </td>
          <td v-else> {{ this.selectedFile.name }}
            <button @click="FileConfirmationUpload" :disabled="isFileUploadDisabled">Загрузить</button>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
    <div v-if="!invoice.cancelled">
      <div v-if="invoice.type_id === 1 || invoice.type_id === 4" class="row">
        <button v-show="invoice.doc_type === 1" class="btn btn-outline-primary btn-download"
                v-bind:class="isInvoiceError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadInvoice"
                :disabled="(isReloadDisabled || isInvoiceDisabled)">
          <span v-if="!isInvoiceDisabled  && invoice.country_id !== 'de'">УПД</span>
          <span v-if="!isInvoiceDisabled  && invoice.country_id === 'de'">Rechnung</span>
          <span v-if="isInvoiceDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-show="invoice.doc_type === 2 && invoice.aggregationType.id !== 3"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isActError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadAct"
                :disabled="(isReloadDisabled || isActDisabled)">
          <span v-if="!isActDisabled">Акт</span>
          <span v-if="isActDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-show="invoice.doc_type === 3"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isKs2Error ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadKs2"
                :disabled="(isReloadDisabled || isKs2Disabled)">
          <span v-if="!isKs2Disabled">КС-2</span>
          <span v-if="isKs2Disabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-show="invoice.doc_type === 3"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isKs3Error ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadKs3"
                :disabled="(isReloadDisabled || isKs3Disabled)">
          <span v-if="!isKs3Disabled">КС-3</span>
          <span v-if="isKs3Disabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button
            v-show="(invoice.doc_type === 2 || invoice.doc_type === 3) && invoice.country_id === 'ru'  && invoice.franchise_id !== 4"
            class="btn btn-outline-primary btn-download"
            v-bind:class="isSfError ? 'btn-outline-danger' : 'btn-outline-primary'"
            @click="downloadSf"
            :disabled="(isReloadDisabled || isSfDisabled)">
          <span v-if="!isSfDisabled">Счет-фактура</span>
          <span v-if="isSfDisabled" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
        </button>
        <button v-if="isCredit && (invoice.country_id !== 'de' || invoice.customer_id == 2263)"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isBillError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadBill"
                :disabled="(isReloadDisabled || isBillDisabled)">
          <span v-if="!isBillDisabled">Счет</span>
          <span v-if="isBillDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="invoice.type_id === 2 && (invoice.country_id !== 'de' || invoice.customer_id == 2263)"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isBillError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadBill"
                :disabled="(isReloadDisabled || isBillDisabled)">
          <span v-if="!isBillDisabled">Счет</span>
          <span v-if="isBillDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="isConfirmationRequired && isConfirmationDownloadEnabled"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isConfirmationError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadConfirmation"
                :disabled="(isReloadDisabled || isConfirmationDisabled)">
          <span v-if="!isConfirmationDisabled">Согласование</span>
          <span v-if="isConfirmationDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="isReportDownloadEnabled" class="btn btn-outline-primary btn-download"
                v-bind:class="isReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadReport"
                :disabled="(isReloadDisabled || isReportDisabled)">
          <span v-if="!isReportDisabled">Отчет</span>
          <span v-if="isReportDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="isUniversalReportDownloadEnabled" class="btn btn-outline-primary btn-download"
                v-bind:class="isUniversalReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadUniversalReport"
                :disabled="(isReloadDisabled || isUniversalReportDisabled)">
          <span v-if="!isUniversalReportDisabled">Report</span>
          <span v-if="isUniversalReportDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                        </span>
        </button>
        <button v-if="isCleaningReportEnabled"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isCleaningReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadCleaningReport"
                :disabled="(isReloadDisabled || isCleaningReportDisabled)">
          <span v-if="!isCleaningReportDisabled">Акты свод</span>
          <span v-if="isCleaningReportDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="isMtsReportDownloadEnabled"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isMtsReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadReportMts"
                :disabled="(isReloadDisabled || isMtsReportDisabled)">
          <span v-if="!isMtsReportDisabled">Отчет МТС</span>
          <span v-if="isMtsReportDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>

        <!--        <button v-show="invoice.doc_type === 1" class="btn btn-outline-primary btn-download"-->
        <!--                v-bind:class="isReportError ? 'btn-outline-danger' : 'btn-outline-primary'"-->
        <!--                @click="downloadReport"-->
        <!--                :disabled="(isReloadDisabled || isReportDisabled)">-->
        <!--          <span v-if="!isReportDisabled">Отчет</span>-->
        <!--          <span v-if="isReportDisabled" class="spinner-border spinner-border-sm" role="status"-->
        <!--                aria-hidden="true">-->
        <!--                </span>-->
        <!--        </button>-->
        <!--                <button v-if="isCredit && invoice.country_id === 'ru'"-->
        <!--                        class="btn btn-outline-primary btn-download"-->
        <!--                        v-bind:class="isBillCleanError ? 'btn-outline-danger' : 'btn-outline-primary'"-->
        <!--                        @click="downloadBillClean"-->
        <!--                        :disabled="(isReloadDisabled || isBillCleanDisabled)">-->
        <!--                    <span v-if="!isBillCleanDisabled">СчетБП</span>-->
        <!--                    <span v-if="isBillCleanDisabled" class="spinner-border spinner-border-sm" role="status"-->
        <!--                          aria-hidden="true">-->
        <!--                </span>-->
        <!--                </button>-->
      </div>
      <div v-if="invoice.type_id === 3" class="row">
        <button v-if="isCreditNoteDownloadEnabled" class="btn btn-outline-primary btn-download"
                v-bind:class="isBillError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadCreditNote"
                :disabled="(isReloadDisabled || isBillDisabled)">
          <span v-if="!isBillDisabled">Gutschrift</span>
          <span v-if="isBillDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
        <button v-if="isCleaningReportEnabled"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isCleaningReportError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadCleaningReport"
                :disabled="(isReloadDisabled || isCleaningReportDisabled)">
          <span v-if="!isCleaningReportDisabled">Акты свод</span>
          <span v-if="isCleaningReportDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
      </div>
      <div v-if="invoice.type_id === 2" class="row">
        <button v-if="invoice.type_id === 2 && invoice.country_id !== 'de'"
                class="btn btn-outline-primary btn-download"
                v-bind:class="isBillError ? 'btn-outline-danger' : 'btn-outline-primary'"
                @click="downloadBill"
                :disabled="(isReloadDisabled || isBillDisabled)">
          <span v-if="!isBillDisabled">Счет</span>
          <span v-if="isBillDisabled" class="spinner-border spinner-border-sm" role="status"
                aria-hidden="true">
                </span>
        </button>
      </div>


    </div>

    <div v-if="output">
      <h6>Лог</h6>
      <table class="table table-sm text-left">
        <tbody>
        <tr v-for="item in output.log">
          <td style="width: 200px">{{ item.date }}</td>
          <td>{{ item.message }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

function compare(a, b) {
  if (a.name === undefined || b.name === undefined) {
    return 0
  }
  if (a.name.toLowerCase() < b.name.toLowerCase())
    return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase())
    return 1;

  return 0;
}

export default {
  name: 'InvoiceInfo',
  data() {
    return {
      doc_id: null,
      invoice: null,
      output: null,
      reloadDisabled: false,
      invoiceDisabled: false,
      invoiceCancelDisabled: false,
      actDisabled: false,
      ks2Disabled: false,
      ks3Disabled: false,
      sfDisabled: false,
      billDisabled: false,
      cleaningReportDisabled: false,
      mtsReportDisabled: false,
      confirmationDisabled: false,
      billCleanDisabled: false,
      reportDisabled: false,
      universalReportDisabled: false,
      isGenError: false,
      isInvoiceError: false,
      isBillError: false,
      isConfirmationError: false,
      isUniversalReportError: false,
      isReportError: false,
      isCleaningReportEnabled: false,
      isCleaningReportError: false,
      isMtsReportEnabled: false,
      isMtsReportError: false,
      isBillCleanError: false,
      isActError: false,
      isKs2Error: false,
      isKs3Error: false,
      isSfError: false,
      editInvoice: false,
      isStatusDigitalNextDisabled: false,
      invoiceEditDisabled: false,
      createCustomReportDisabled: false,
      uploadContractorInvoices: false,
      signers: [],
      templates: [],
      legalEntities: [],
      departments: [],
      branches: [],
      contracts: [],
      franchises: [],
      aggregationTypes: [],
      message: '',
      unblockReason: '',
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
      statusList: {
        1: "Подготовлен",
        2: "Создан",
        3: "На согласовании",
        4: "Согласован",
        5: "Не согласован",
        6: "Отправлен",
        7: "Подписан",
        8: "Отклонен",
        9: "Аннулирован",
      },
      fileUploadDisabled: false,
      selectedFile: null,
      invoiceFile: null,
      invoiceConfirmationFile: null,
      selectedFileDocType: "",

    };
  },
  computed: {
    isExist() {
      return this.invoice && this.invoice.guid !== "";
    },
    isCredit() {
      return this.invoice && this.invoice.payment_type_id === 2;
    },
    isCreateDisabled() {

      let disabled = false;

      if (this.invoice && (this.invoice.status === 6 || this.invoice.status === 7 || this.invoice.status === 9 || this.invoice.type_id === 4)) {
        disabled = true;
      }

      if (this.invoice && !(this.$store.getters.isAdmin || this.$store.getters.isDocEditAllowed)) {
        disabled = true;
      }

      return disabled;
    },
    isReloadDisabled() {
      return this.reloadDisabled;
    },
    isInvoiceDisabled() {
      return this.invoiceDisabled;
    },
    isCancelDisabled() {
      return this.invoiceCancelDisabled;
    },
    isReportDisabled() {
      return this.reportDisabled;
    },
    isUniversalReportDisabled() {
      return this.universalReportDisabled;
    },
    isBillDisabled() {
      return this.billDisabled;
    },
    isCleaningReportDisabled() {
      return this.cleaningReportDisabled;
    },
    isMtsReportDisabled() {
      return this.mtsReportDisabled;
    },
    isConfirmationDisabled() {
      return this.confirmationDisabled;
    },
    isBillCleanDisabled() {
      return this.billCleanDisabled;
    },
    isActDisabled() {
      return this.actDisabled;
    },
    isKs2Disabled() {
      return this.ks2Disabled;
    },
    isKs3Disabled() {
      return this.ks3Disabled;
    },
    isSfDisabled() {
      return this.sfDisabled;
    },
    isCancelled() {
      return this.invoice.cancelled;
    },
    isSendEDIAllowed() {
      return this.invoice.status === 2 || this.invoice.status === 4;
    },
    isBlocked() {
      return this.invoice.is_blocked;
    },
    isOverdue() {
      let today = new Date();
      let due_date = new Date(this.invoice.due_date);

      return (due_date) < today && this.invoice.payment_type_id === 2 && this.invoice.debt_sum > 0;
    },
    daysOverdue() {

      if (this.invoice.payment_type_id === 1) {
        return 0
      }

      if (this.invoice.debt_sum < 1) {
        return 0
      }

      const oneDay = 24 * 60 * 60 * 1000;

      let today = new Date()
      return Math.round(Math.abs((today - this.invoice.due_date) / oneDay));
    },
    isGutschrift() {
      return this.invoice.type_id === 3;
    },
    isConfirmationRequired() {
      return this.invoice.department_id === 1569 || this.invoice.department_id === 1287 || this.invoice.department_id === 1351 || this.invoice.department_id === 1881 || this.invoice.department_id === 2182 || this.invoice.department_id === 2232;
    },
    isFilePrepared() {
      return this.selectedFile !== null;
    },
    isFileUploadDisabled() {
      return this.fileUploadDisabled;
    },
    isCreditNoteDownloadEnabled() {
      return this.invoiceFile !== null;
    },
    isConfirmationDownloadEnabled() {
      return this.invoiceConfirmationFile !== null;
    },
    isReportDownloadEnabled() {
      return true;
    },
    isMtsReportDownloadEnabled() {
      return this.invoice != null && (this.invoice.customer_id === 73);
    },
    isUniversalReportDownloadEnabled() {
      return this.invoice && this.invoice.country_id === 'de';
    },
    isCreateCustomReportDisabled() {
      return this.createCustomReportDisabled;
    },
    isUploadContractorInvoices() {
      return this.uploadContractorInvoices;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isUploadContractorInvoicesAllowed() {
      return this.invoice != null && (this.invoice.customer_id == 811);
    },
  },

  methods: {

    createInvoice() {
      this.reloadDisabled = true;
      this.output = null;
      this.isGenError = false;
      this.message = '';

      axios.get(`/docs/create/${this.invoice.id}`)
          .then((res) => {
            this.isGenError = false;
            console.log(res.data);
            this.output = res.data;
            this.updatePrintForms();
          })
          .catch((error) => {
            this.isGenError = true;
            console.log(error);
            console.log(error.response);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.reloadDisabled = false;

            axios.get(`/doc_by_id`, {
              params: {
                country_id: this.$route.params.countryID,
                invoice_id: this.$store.state.currentDocId,
              },
            })
                .then((res) => {
                  console.log(res.data);

                  res.data.doc_date = new Date(res.data.doc_date);
                  res.data.date_of_completion = new Date(res.data.date_of_completion);

                  // res.data.due_date = new Date(res.data.due_date);
                  // res.data.service_period_start = new Date(res.data.service_period_start);
                  // res.data.service_period_end = new Date(res.data.service_period_end);

                  this.invoice = res.data;
                })
                .catch((error) => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                })
          });
    },


    cancelInvoice() {

      this.invoiceCancelDisabled = true;
      this.output = null;
      this.isGenError = false;
      this.message = '';

      axios.delete(`/docs/${this.invoice.id}`)
          .then((response) => {
            this.isGenError = false;
            this.invoice.cancelled = true;
          })
          .catch((error) => {
            this.isGenError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.invoiceCancelDisabled = false;
            axios.get(`/doc_by_id`, {
              params: {
                invoice_id: this.invoice.external_id,
                country_id: this.invoice.country_id,
              },
            })
                .then((res) => {
                  console.log(res.data);

                  res.data.doc_date = new Date(res.data.doc_date);
                  res.data.date_of_completion = new Date(res.data.date_of_completion);

                  // res.data.due_date = new Date(res.data.due_date);
                  // res.data.service_period_start = new Date(res.data.service_period_start);
                  // res.data.service_period_end = new Date(res.data.service_period_end);

                  this.invoice = res.data;
                })
                .catch((error) => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                })
          });
    },

    unblockInvoiceStart() {
      this.reloadDisabled = true;
    },

    blockInvoice() {

      this.message = '';
      this.reloadDisabled = false;

      axios.post(`/docs/${this.invoice.id}/block`)
          .then((response) => {
            this.invoice.is_blocked = false;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.loadInvoice();
          });
    },

    unblockInvoice() {

      this.message = '';
      this.reloadDisabled = false;

      axios.post(`/docs/${this.invoice.id}/unblock`, {
        reason: "admin unblock"
      })
          .then((response) => {
            this.invoice.is_blocked = true;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.loadInvoice();
          });
    },

    restoreInvoice() {
      axios.post(`/docs/${this.invoice.id}/restore`)
          .then((response) => {
            this.invoice.cancelled = false;
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
          });
    },

    updatePrintForms() {
      this.reloadDisabled = true;
      this.invoiceDisabled = true;
      this.actDisabled = true;
      this.ks2Disabled = true;
      this.ks3Disabled = true;
      this.sfDisabled = true;
      this.billDisabled = true;
      this.billCleanDisabled = true;
      this.reportDisabled = true;
      console.log("reloadDisabled disabled");
      axios.get(`/docs/${this.invoice.id}/update_print_forms`)
          .then((response) => {
            console.log(response.data);
          })
          .catch((error) => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.reloadDisabled = false;
            this.invoiceDisabled = false;
            this.actDisabled = false;
            this.ks2Disabled = false;
            this.ks3Disabled = false;
            this.sfDisabled = false;
            this.billDisabled = false;
            this.billCleanDisabled = false;
            this.reportDisabled = false;

          });
    },

    downloadInvoice() {
      this.invoiceDisabled = true;
      this.isInvoiceError = false;
      console.log("invoice disabled");

      let number = this.invoice.external_id
      let fileExtension = 'УПД';
      if (this.invoice.country_id === 'de') {
        number = this.invoice.number
        if (this.invoice.type_id === 1) {
          fileExtension = 'Rechnung';
        }
        if (this.invoice.type_id === 3) {
          fileExtension = 'Gutschrift';
        }
      }

      axios.get(`/docs/${this.invoice.id}/download?type=invoice`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${number}_${fileExtension}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isInvoiceError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.invoiceDisabled = false;
          });
    },

    downloadAct() {
      this.actDisabled = true;
      this.isActError = false;
      console.log("Act disabled");
      axios.get(`/docs/${this.invoice.id}/download?type=act`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `wa-${this.invoice.external_id}_Акт.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isActError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.actDisabled = false;
          });
    },

    downloadKs2() {
      this.ks2Disabled = true;
      this.isKs2Error = false;
      axios.get(`/docs/${this.invoice.id}/download?type=ks2`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${this.invoice.external_id}_КС2.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isKs2Error = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.ks2Disabled = false;
          });
    },


    downloadKs3() {
      this.ks3Disabled = true;
      this.isKs3Error = false;
      axios.get(`/docs/${this.invoice.id}/download?type=ks3`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${this.invoice.external_id}_КС3.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isKs3Error = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.ks3Disabled = false;
          });
    },


    downloadSf() {
      this.sfDisabled = true;
      this.isSfError = false;
      axios.get(`/docs/${this.invoice.id}/download?type=sf`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `wa-${this.invoice.external_id}_СФ.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isSfError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.sfDisabled = false;
          });
    },

    downloadBill() {
      this.billDisabled = true;
      this.isBillError = false;

      let invType = 'bill'
      if (this.invoice.customer_id == 2263) {
        invType = "order_confirmation";
      }

      axios.get(`/docs/${this.invoice.id}/download?type=${invType}`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `wa-${this.invoice.external_id}_Счет.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isBillError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.billDisabled = false;
          });
    },

    downloadCleaningReport() {
      this.cleaningReportDisabled = true;
      this.isCleaningReportError = false;
      axios.get(`/docs/${this.invoice.id}/download?type=cleaning_report`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `wa-${this.invoice.external_id}_CleaningReport.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isCleaningReportError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.cleaningReportDisabled = false;
          });
    },

    downloadCreditNote() {
      this.billDisabled = true;
      this.isBillError = false;
      axios.get(`/docs/${this.invoice.id}/download?type=credit_note`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `GU-${this.invoice.number}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isBillError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.billDisabled = false;
          });
    },

    downloadConfirmation() {
      this.confirmationDisabled = true;
      this.isConfirmationError = false;
      axios.get(`/docs/${this.invoice.id}/download?type=confirmation`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `C-${this.invoice.number}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isConfirmationError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.confirmationDisabled = false;
          });
    },

    downloadBillClean() {
      this.billCleanDisabled = true;
      this.isBillCleanError = false;
      axios.get(`/docs/${this.invoice.id}/download?type=bill_clean`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `wa-${this.invoice.extrnal_id}_СчетБП.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isBillCleanError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.billCleanDisabled = false;
          });
    },

    downloadUniversalReport() {
      this.universalReportDisabled = true;
      this.isUniversalReportError = false;
      axios.get(`/docs/${this.invoice.id}/download_report`, {responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${this.invoice.external_id}_universal_report.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isReportError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.reportDisabled = false;
          });
    },

    downloadReport() {
      this.reportDisabled = true;
      this.isReportError = false;

      let reportType = "universal";

      if (this.invoice.customer_id == 466) {
        reportType = "galamart";
      }

      axios.get(`/docs/${this.invoice.id}/download_report`, {
        responseType: 'blob', params: {
          type: reportType,
          // type: "oldWowworks",
        },
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${this.invoice.external_id}_report.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isReportError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.reportDisabled = false;
          });
    },

    downloadReportMts() {
      this.mtsReportDisabled = true;
      this.isMtsReportError = false;
      axios.get(`/docs/${this.invoice.id}/download_report`, {
        responseType: 'blob', params: {
          // type: "rtk",
          type: "rtkByShop",
        },
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_self';
            link.setAttribute('download', `${this.invoice.external_id}_report.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            this.isMtsReportError = true;
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.mtsReportDisabled = false;
          });
    },


    updateSinger() {
      this.invoice.signer = this.signers.find(s => s.id === this.invoice.signer_id);
    },

    updateTemplate() {
      this.invoice.item_template = this.templates.find(s => s.id === this.invoice.gen_type);
    },

    updateSum() {
      this.invoice.summ = Number(this.invoice.summ);
    },

    updateDocDate(event) {
      this.invoice.doc_date = event.target.valueAsDate;
    },

    updateDateOfCompletion(event) {
      this.invoice.date_of_completion = event.target.valueAsDate;
    },

    updateLegalEntity() {
      this.invoice.legal_entity = this.legalEntities.find(s => s.id === this.invoice.legal_entity_id);
      this.invoice.contracts = this.contracts.filter(contract =>
          contract.legal_entity_id === this.invoice.legal_entity_id &&
          contract.franchise_id === this.invoice.franchise_id &&
          contract.department_id === this.invoice.department_id &&
          contract.branch_id === this.invoice.branch_id
      );

      if (this.invoice.contracts.length > 0) {
        this.invoice.contract = this.invoice.contracts[0];
        this.invoice.contract_id = this.invoice.contract.id;
      } else {
        this.invoice.contract = null
        this.invoice.contract_id = 0
      }


    },

    updateFranchise() {
      this.invoice.franchise = this.franchises.find(s => s.id === this.invoice.franchise_id);

      //filter le by franchise and contract
      let contractsForFranchise = this.contracts.filter(item =>
          item.franchise_id === this.invoice.franchise_id
      );

      let contractLEidS = contractsForFranchise.map(c => c.legal_entity_id);
      // console.log("contractLEidS");
      // console.log(contractLEidS);

      this.invoice.legalEntities = this.legalEntities.filter(item =>
          contractLEidS.includes(item.id) > 0
      );

      console.log("this.invoice.legalEntities");
      console.log(this.invoice.legalEntities);

      if (this.invoice.legalEntities.includes(this.invoice.legal_entity_id) <= 0) {

        if (this.invoice.legalEntities.length > 0) {
          this.invoice.legal_entity = this.invoice.legalEntities[0];
          this.invoice.legal_entity_id = this.invoice.legal_entity.id;
        }
      }

      this.invoice.contracts = this.contracts.filter(contract =>
          contract.legal_entity_id === this.invoice.legal_entity_id &&
          contract.franchise_id === this.invoice.franchise_id &&
          contract.department_id === this.invoice.department_id &&
          contract.branch_id === this.invoice.branch_id
      );

      if (this.invoice.contracts.length > 0) {
        this.invoice.contract = this.invoice.contracts[0];
        this.invoice.contract_id = this.invoice.contract.id;
      }


    },

    updateDepartment() {
      this.invoice.department = this.departments.find(s => s.id === this.invoice.department_id);

      this.invoice.contracts = this.contracts.filter(contract =>
          contract.legal_entity_id === this.invoice.legal_entity_id &&
          contract.franchise_id === this.invoice.franchise_id &&
          contract.department_id === this.invoice.department_id &&
          contract.branch_id === this.invoice.branch_id
      );

      const result = this.invoice.contracts.find(contract => contract.id === this.invoice.contract_id);
      if (result === undefined) {
        if (this.invoice.contracts.length > 0) {
          this.invoice.contract = this.invoice.contracts[0];
          this.invoice.contract_id = this.invoice.contract.id;
        } else {
          this.invoice.contract = undefined;
          this.invoice.contract_id = 0;
        }
      }

    },

    updateBranch() {
      this.invoice.branch = this.branches.find(s => s.id === this.invoice.branch_id);

      this.invoice.contracts = this.contracts.filter(contract =>
          contract.legal_entity_id === this.invoice.legal_entity_id &&
          contract.franchise_id === this.invoice.franchise_id &&
          contract.department_id === this.invoice.department_id &&
          contract.branch_id === this.invoice.branch_id
      );

      const result = this.invoice.contracts.find(contract => contract.id === this.invoice.contract_id);
      if (result === undefined) {
        if (this.invoice.contracts.length > 0) {
          this.invoice.contract = this.invoice.contracts[0];
          this.invoice.contract_id = this.invoice.contract.id;
        } else {
          this.invoice.contract = undefined;
          this.invoice.contract_id = 0;
        }
      }

    },

    updateContract() {
      this.invoice.contract = this.invoice.contracts.find(s => s.id === this.invoice.contract_id);

    },

    updateStatusDigital(status) {
      this.invoice.status = status;

    },

    updateAggregationType() {
      this.invoice.aggregationType = this.aggregationTypes.find(s => s.id === this.invoice.aggregation_id);
    },

    saveInvoice() {

      console.log('Invoice save: prepare');

      this.editInvoice = false;
      this.invoiceEditDisabled = true;
      this.message = '';

      let invForSave = JSON.parse(JSON.stringify(this.invoice));

      // invForSave.doc_date = new Date(invForSave.doc_date);
      // invForSave.date_of_completion = new Date(invForSave.date_of_completion);

      // invForSave.date_completed = new Date(invForSave.date_completed);

      // console.log(typeof this.invoice.doc_date);
      // console.log(typeof this.invoice.date_of_completion);

      // if (this.invoice.doc_date instanceof Date) {
      //   console.log("This is a Date object");
      // } else {
      //   console.log("This is not a Date object");
      // }

      // console.log("this.invoice.doc_date = " + this.invoice.doc_date);
      // console.log("invForSave.doc_date = " + invForSave.doc_date);

      invForSave.doc_date = this.invoice.doc_date.toISOString().split('T')[0];
      invForSave.date_of_completion = this.invoice.date_of_completion.toISOString().split('T')[0];

      // console.log("invForSave prepared");
      // console.log("this.invoice.doc_date = " + this.invoice.doc_date);
      // console.log("invForSave.doc_date = " + invForSave.doc_date);

      // console.log(typeof invForSave.doc_date);
      // console.log(typeof invForSave.date_of_completion);

      // invForSave.date_completed = invForSave.date_completed.toISOString().split('T')[0];
      // invForSave.service_period_start = invForSave.service_period_start.toISOString().split('T')[0];
      // invForSave.service_period_end = invForSave.service_period_end.toISOString().split('T')[0];

      axios.put(`/docs/${this.invoice.id}`, invForSave)
          .then((res) => {
            console.log('Invoice saved successfully');
            console.log(res.data);
          })
          .catch((error) => {
            console.log('Invoice saved error');
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            console.log('Invoice saved finally');
            this.invoiceEditDisabled = false;
          });
    },

    openInvoiceEdit() {
      this.editInvoice = true;
    },

    OnFileConfirmationChanged(event) {
      this.selectedFile = event.target.files[0];

      this.FileConfirmationUpload();
    },

    OnFileGutschriftChanged(event) {
      this.selectedFile = event.target.files[0];
      this.FileGutschriftUpload();
    },

    FileGutschriftUpload() {
      const params = new FormData()
      params.set('docType', 'credit_note');
      params.append('file', this.selectedFile, this.selectedFile.name);

      this.fileUploadDisabled = true;
      axios.post(`/docs/${this.invoice.id}/upload`, params)

          .then((res) => {
            console.log(res.data);
            this.GetInvoiceFile();
            this.selectedFile = null;
            this.fileUploadDisabled = false;
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    FileConfirmationUpload() {
      const params = new FormData()
      params.set('docType', 'confirmation');
      params.append('file', this.selectedFile, this.selectedFile.name);

      this.fileUploadDisabled = true;
      axios.post(`/docs/${this.invoice.id}/upload`, params)

          .then((res) => {
            console.log(res.data);
            this.GetInvoiceConfirmationFile();
            this.selectedFile = null;
            this.fileUploadDisabled = false;
          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    GetInvoiceFile() {
      axios.get(`/docs/${this.invoice.id}/file`, {
        params: {
          docType: 'credit_note',
        },
      })
          .then((res) => {
            // console.log(res.data);
            this.invoiceFile = res.data;

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    GetInvoiceConfirmationFile() {
      axios.get(`/docs/${this.invoice.id}/file`, {
        params: {
          docType: 'confirmation',
        },
      })
          .then((res) => {
            // console.log(res.data);
            this.invoiceConfirmationFile = res.data;

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    CreateCustomReport() {

      this.createCustomReportDisabled = true;
      axios.get(`/docs/${this.invoice.id}/create_custom_report`)
          .then((res) => {

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.createCustomReportDisabled = false;
          })
      ;
    },

    UploadContractorInvoices() {

      this.uploadContractorInvoices = true;
      axios.get(`/invoice/${this.invoice.id}/upload_contractor_invoices`)
          .then((res) => {

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.uploadContractorInvoices = false;
          })
      ;
    },

    loadInvoice() {
      axios.get(`/doc_by_id`, {
        params: {
          country_id: this.$route.params.countryID,
          invoice_id: this.$store.state.currentDocId,
        },
      })
          .then((res) => {
            console.log(res.data);

            res.data.doc_date = new Date(res.data.doc_date);
            res.data.date_of_completion = new Date(res.data.date_of_completion);

            // res.data.due_date = new Date(res.data.due_date);
            // res.data.service_period_start = new Date(res.data.service_period_start);
            // res.data.service_period_end = new Date(res.data.service_period_end);

            res.data.contract.link = 'https://admin.' + this.portalUrl[res.data.country_id] + '/contract/view?id=' + res.data.contract.external_id;
            res.data.customer.link = 'https://admin.' + this.portalUrl[res.data.country_id] + '/organization/view?id=' + res.data.customer.external_id;

            console.log(res.data);

            this.invoice = res.data;

            //Леруа, Ригла, Мегастрой
            if (this.invoice.department_id === 1287
                || this.invoice.department_id === 1786
                || this.invoice.department_id === 330
                || this.invoice.department_id === 328
                || this.invoice.department_id === 2556
                || this.invoice.department_id === 2280
                || this.invoice.department_id === 2582 //	Аскона B2C
                || this.invoice.department_id === 2269) {
              this.isCleaningReportEnabled = true;
            }

            this.GetInvoiceFile();
            this.GetInvoiceConfirmationFile();

            document.title = this.invoice ? this.invoice.external_id.toString() : '';

            axios.get(`/docs/${this.invoice.id}/edi_state`)
                .then((res) => {
                  // console.log(res.data);
                  if (res.data != null) {
                    this.invoice.edi_status = res.data.docStatus;
                    this.invoice.edi_state = res.data.ediState.agreement + " [" + res.data.ediState.recipient_provider + "]";

                    if (res.data.reasonRejection !== '') {
                      this.invoice.edi_status += ' (' + res.data.reasonRejection + ')';
                    }
                  }

                })
                .catch(error => {
                  console.log(error);
                  //this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });

            axios.get(`/templates`, {
              params: {
                invoice_id: this.invoice.id
              }
            })
                .then((res) => {
                  // console.log(res.data);
                  this.templates = res.data;
                  console.log(this.templates);
                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });

            axios.get(`/customer/${this.invoice.customer_id}/legal_entities`)
                .then((res) => {
                  // console.log(res.data);
                  this.legalEntities = res.data;
                  console.log(this.legalEntities);


                  this.legalEntities = this.legalEntities.filter(le =>
                      le.is_deleted === false
                  );

                  this.legalEntities.sort(compare);

                  this.invoice.legalEntities = [...this.legalEntities];

                  axios.get(`/customer/${this.invoice.customer_id}/contracts`)
                      .then((res) => {
                        // console.log(res.data);
                        this.contracts = res.data;
                        console.log(this.contracts);

                        this.contracts.sort(compare);

                        this.invoice.contracts = this.contracts.filter(contract =>
                            contract.legal_entity_id === this.invoice.legal_entity_id
                        );

                        axios.get(`/customer/${this.invoice.customer_id}/franchises`)
                            .then((res) => {
                              // console.log(res.data);
                              this.franchises = res.data;
                              //console.log(this.contracts);

                              this.franchises.sort(compare);

                              //filter franchises
                              let cf = this.contracts.map(c => c.franchise_id);
                              console.log("cf");
                              console.log(cf);

                              this.franchises = this.franchises.filter(fr =>
                                  cf.includes(fr.id) > 0
                              );

                              this.invoice.contracts = this.contracts.filter(contract =>
                                  contract.legal_entity_id === this.invoice.legal_entity_id &&
                                  contract.franchise_id === this.invoice.franchise_id &&
                                  contract.department_id === this.invoice.department_id &&
                                  contract.branch_id === this.invoice.branch_id
                              );

                            })
                            .catch(error => {
                              console.log(error);
                              this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                            });


                        //filter le by franchise and contract
                        let contractsForFranchise = this.contracts.filter(item =>
                            item.franchise_id === this.invoice.franchise_id
                        );

                        let contractLEidS = contractsForFranchise.map(c => c.legal_entity_id);
                        // console.log("contractLEidS");
                        // console.log(contractLEidS);

                        this.invoice.legalEntities = this.invoice.legalEntities.filter(item =>
                            contractLEidS.includes(item.id) > 0
                        );

                        // console.log("this.invoice.legalEntities");
                        // console.log(this.invoice.legalEntities);

                      })
                      .catch(error => {
                        console.log(error);
                        this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                      });

                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });


            axios.get(`/customer/${this.invoice.customer_id}/departments`)
                .then((res) => {
                  // console.log(res.data);
                  this.departments = res.data;
                  console.log(this.departments);

                  this.departments = this.departments.filter(d =>
                      d.is_deleted === false
                  );

                  this.departments.sort(compare);
                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });

            axios.get(`/customer/${this.invoice.customer_id}/branches`)
                .then((res) => {
                  // console.log(res.data);
                  this.branches = res.data;
                  console.log(this.branches);

                  this.branches = this.branches.filter(b =>
                      b.is_deleted === false
                  );

                  this.branches.sort(compare);
                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });


            axios.get(`/aggregation_types`)
                .then((res) => {
                  // console.log(res.data);
                  this.aggregationTypes = res.data;
                  console.log(this.aggregationTypes);

                  this.aggregationTypes.sort(compare);

                  if (this.invoice.customer_id != 545) {
                    this.aggregationTypes.forEach(function (item, index, object) {
                      if (item.id === 3) {
                        object.splice(index, 1);
                      }
                    })

                  }
                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });

            axios.get(`/signers`)
                .then((res) => {
                  // console.log(res.data);
                  this.signers = res.data;
                  console.log(this.signers);
                })
                .catch(error => {
                  console.log(error);
                  this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
                });
          })
          .catch(error => console.log(error))
    }

  },


  beforeCreate() {

  },

  created() {

    this.doc_id = this.$store.state.currentDocId;
    this.loadInvoice();

  },
}
;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
}

.btn-download {
  margin-left: 15px;
  width: 140px;
}

.table-td {
  width: 280px;
}
</style>
